import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { DrawerBody, DrawerFooter } from '@fiverr-private/overlay';
import { AppI18n, appTranslate } from '../../i18n';
import { Step } from '../../constants';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { briefCreationClickAction } from '../../monitoring/bqEvents';
import { MoreInformationImage } from './MoreInformationImage';
import { RephraseExamples } from './RephraseExamples';

export const RephraseStep = () => {
  const { currentStep, setStep, contextId, source, regenerateContextId, variant, parentElement } =
    useBriefCreationContext();

  const goBack = () => {
    briefCreationClickAction({
      step: currentStep,
      action: 'rephrase',
      briefContextId: contextId,
      eventSource: source || '',
      parentElement,
      variant,
    });
    setStep(Step.Creation);

    // force re-generation of new context ID
    regenerateContextId();
  };

  return (
    <>
      <DrawerBody>
        <Stack
          direction="column"
          gap="8"
          alignItems="center"
          justifyContent="center"
          marginTop="7"
          paddingX="5"
          height="100%"
        >
          <Stack direction="column" gap="6" alignItems="center" textAlign="center">
            <MoreInformationImage />
            <Heading size="h_sm">{appTranslate('rephrase_step.title')}</Heading>
            <Container>
              <Text size="b_sm">{appTranslate('rephrase_step.description_1')}</Text>
            </Container>
          </Stack>

          <RephraseExamples />
        </Stack>
      </DrawerBody>
      <DrawerFooter>
        <Stack direction="row" justifyContent="flexEnd">
          <Button onClick={goBack}>
            <AppI18n k="back" />
          </Button>
        </Stack>
      </DrawerFooter>
    </>
  );
};
